import React from "react";
import LeftBox from "./LeftBox";
import RightBox from "./RightBox";

const CategoryComponent = ({
  className,
  leftBoxProps,
  rightBoxProps,
  show,
  showLeft = true,
}) => (
  <>
    <div className={`category-container ${className}`}>
      {showLeft && <LeftBox {...leftBoxProps} show={show} />}
      <RightBox {...rightBoxProps} />
    </div>
  </>
);

export default CategoryComponent;
